import { Pressable } from '@rbilabs/universal-components';
import { View } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native';

import { LayoutContainer } from 'components/layout/styled';
import Picture from 'components/picture';
import { spacing } from 'styles/constants';

import { CTAButtons } from '../components/cta-button';
import { ISimpleHomePageProps } from '../types';
import { sendHeroClickEvent } from '../utils';

import { ButtonsContainer, DisclaimerText, HeaderStyled } from './styled';

export const SimpleHomePageDesktop = ({
  numberOfItemsInCart,
  serviceMode,
  item,
}: ISimpleHomePageProps) => {
  const { header, desktopImage, altImageText, _id, imageLink, imageDisclaimerText, daypart } = item;
  const headerText = header?.locale ?? '';
  const imageAlt = altImageText?.locale ?? '';
  const image = desktopImage?.locale;
  const { navigate } = useRouter();

  const handleOnPress = () => {
    if (imageLink) {
      sendHeroClickEvent({ imageLink, daypart });

      navigate(imageLink);
    }
  };

  return (
    <LayoutContainer testID="simple-home-page" style={styles.container} paddingTop={'$6'}>
      <View style={styles.left}>
        <HeaderStyled accessibilityLabel={headerText}>{headerText}</HeaderStyled>
        <ButtonsContainer>
          <CTAButtons
            numberOfItemsInCart={numberOfItemsInCart}
            serviceMode={serviceMode}
            itemId={_id}
          />
        </ButtonsContainer>
      </View>
      <View style={styles.right}>
        {image && (
          <Pressable
            onPress={handleOnPress}
            style={{
              flex: 1,
              cursor: imageLink ? 'pointer' : 'auto',
            }}
          >
            <Picture image={image} alt={imageAlt} />
          </Pressable>
        )}
        {imageDisclaimerText?.locale && (
          <DisclaimerText>{imageDisclaimerText?.locale}</DisclaimerText>
        )}
      </View>
    </LayoutContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  left: {
    flex: 1,
    justifyContent: 'center',
  },
  right: {
    flex: 2,
    marginLeft: spacing.$2,
  },
});
